
import { Component, Vue } from 'vue-property-decorator'
import ScriptLoader from '@/utils/ScriptLoader'
import { NavigationGuardNext, Route } from 'vue-router'
import { Card } from 'ui-library'
import { getPartnerProxyId } from '@/utils/KeycloakUtils'

@Component({
  beforeRouteEnter(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.preloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POSTBOX).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  beforeRouteLeave(to: Route, from: Route, next: NavigationGuardNext) {
    Promise.all([
      ScriptLoader.unloadScript(window.ENV_CONFIG.WEB_COMPONENTS.POSTBOX).catch((_reason) => Promise.resolve())
    ])
      .then(() => next())
      .catch((_reason) => next())
  },
  components: {
    Card
  }
})
export default class PostboxPage extends Vue {
  private partnerProxyId: string | null = null

  public created(): void {
    this.partnerProxyId = getPartnerProxyId()
  }
}
